import React from 'react';

import { capitalizeFirstLetter, getPrimaryUserType } from '@utils/Util';

export const MATERIAL_REQUISITION_PURPOSE = [
	{ constant: 'NITEX_DEVELOPMENT', name: 'Nitex development' },
	{ constant: 'BUYER_REQUEST', name: 'Buyer sample request' },
	{ constant: 'PICK_AND_CHOOSE', name: 'P&C' }
];

export const MATERIAL_REQUISITION_TYPE = [
	{ constant: 'FABRIC', name: 'Fabric' },
	{ constant: 'SWATCH', name: 'Swatch' },
	{ constant: 'TRIMS', name: 'Trims' },
	{ constant: 'ACCESSORIES', name: 'Accessories' }
];

export const COLLECTION_OR_FOLDER_OPTIONS = [
	{ id: 'COLLECTION', value: 'Collection' },
	{ id: 'FOLDER', value: 'Folder' }
];

export const MATERIAL_REJECTION_TYPES = [
	{ constant: 'Inventory exists', name: 'Inventory exists' },
	{ constant: 'OTHER', name: 'Other' }
];

export const isMaterialRequisitionFormValid = (
	selectedMaterialType,
	selectedCollectionOrFolder,
	selectedCollectionOrFolderList,
	inputData,
	selectedMaterialTypeList,
	selectedTrimsAndAccessoriesList,
	materials,
	colorSections,
	selectedBrandList
) => {
	const isSwatchSelected = selectedMaterialType.materialType === MATERIAL_REQUISITION_TYPE[1].constant;
	let errorObj = {};
	if (!inputData?.requiredDate) {
		errorObj['requiredDateError'] = 'Require date is required';
	}
	if (
		!isSwatchSelected &&
		[MATERIAL_REQUISITION_PURPOSE[0].constant, MATERIAL_REQUISITION_PURPOSE[2].constant].includes(
			selectedMaterialType.requisitionPurpose
		)
	) {
		if (!selectedCollectionOrFolder?.id) {
			errorObj['collectionOrFolderTypeError'] = 'Collection or folder type is required';
		}
		if (selectedCollectionOrFolder?.id && selectedCollectionOrFolderList?.length === 0) {
			errorObj['collectionOrFolderError'] =
				`${capitalizeFirstLetter(selectedCollectionOrFolder?.id)} is required`;
		}

		if ([MATERIAL_REQUISITION_TYPE[0].constant].includes(selectedMaterialType.materialType)) {
			if (selectedMaterialTypeList?.length === 0) {
				errorObj['fabricTypeError'] = 'Fabric type is required';
			}
		}
	}
	if (
		[MATERIAL_REQUISITION_TYPE[2].constant, MATERIAL_REQUISITION_TYPE[3].constant].includes(
			selectedMaterialType.materialType
		)
	) {
		if (!selectedTrimsAndAccessoriesList?.id) {
			errorObj['trimsAndAccessoriesError'] =
				`${capitalizeFirstLetter(selectedMaterialType.materialType)} is required`;
		}
		if (!inputData?.quantity) {
			errorObj['quantityError'] = 'Required quantity is required';
		}
	}

	if (
		isSwatchSelected ||
		(selectedMaterialType.requisitionPurpose === MATERIAL_REQUISITION_PURPOSE[1].constant &&
			[MATERIAL_REQUISITION_TYPE[0].constant].includes(selectedMaterialType.materialType))
	) {
		materials.forEach((item, index) => {
			if (item?.materialTypeList?.length === 0 || !item?.materialTypeList) {
				errorObj[`fabricType_${item.uId}`] = 'Fabric type is required';
			}
			if (!item?.weight) {
				errorObj[`weight_${item.uId}`] = 'Weight is required';
			}
			if (
				!item?.quantity &&
				selectedMaterialType.materialType === MATERIAL_REQUISITION_TYPE[0].constant
			) {
				errorObj[`quantity_${item.uId}`] = 'Quantity is required';
			}

			if (item?.colorSections?.length > 0) {
				item.colorSections.forEach((color) => {
					if (
						color?.selectedGroupColorList?.length > 0 ||
						color?.selectedPantoneColorList?.length > 0
					) {
						if (color?.selectedGroupColorList?.length === 0) {
							errorObj[`groupColorError_${item.uId}`] = 'Main color is required';
						}
						if (color?.selectedPantoneColorList?.length === 0) {
							errorObj[`pantoneColorError_${item.uId}`] = 'TCX color is required';
						}
					}
				});
			}

			if (item?.compositions) {
				const totalPercentage = item.compositions.reduce(
					(sum, comp) => sum + (comp?.percentage || 0),
					0
				);
				if (totalPercentage !== 100) {
					item.compositions.forEach((comp, i) => {
						if (!comp?.percentage) {
							errorObj[`composition_percentage_${index}_${i}`] = 'Composition is required';
						}
						if (!comp?.composition) {
							errorObj[`composition_type_${index}_${i}`] = 'Composition type is required';
						}
					});
					errorObj[`composition_percentage_${index}_0`] =
						'Total composition percentage must be 100%';
				}
			} else {
				errorObj[`composition_percentage_${index}_0`] = 'Composition is required';
				errorObj[`composition_type_${index}_0`] = 'Composition type is required';
			}
		});
	}
	if (!selectedBrandList?.value) {
		errorObj['brandError'] = 'Brand is required';
	}

	if (colorSections.length > 0) {
		colorSections.forEach((color) => {
			if (color?.selectedGroupColorList?.length > 0 || color?.selectedPantoneColorList?.length > 0) {
				if (color?.selectedGroupColorList?.length === 0) {
					errorObj['groupColorError'] = 'Main color is required';
				}
				// if (color?.selectedPantoneColorList?.length === 0) {
				// 	errorObj['pantoneColorError'] = 'TCX color is required';
				// }
			}
		});
	}

	return errorObj;
};

export const generateColorDtoList = (colorSections, requestBody) => {
	if (colorSections.length > 0) {
		requestBody.colorMapDTOList = colorSections.map((color) => ({
			colorType: color.colorType,
			addColorDTO: {
				colorType: color.colorType,
				name: color.colorType,
				representedBy: 'PANTONE_OR_HEX_CODE',
				compositeColorList: color.selectedPantoneColorList?.map((pantone) => ({
					id: pantone?.id,
					name: pantone?.name,
					code: pantone?.code,
					hexCode: pantone?.hexCode
				}))
			},
			mainColorIdList: color.selectedGroupColorList?.map((group) => group.id)
		}));
	}
};

export const generatePreliminaryItemForBuyerRequestFabric = (materials, requestBody) => {
	if (materials.length > 0) {
		requestBody.preliminaryItemAddRequestList = materials.map((item) => {
			let color = item.colorSections[0];
			return {
				quantity: item?.quantity,
				fabricConstructionGroupId: item?.materialTypeList?.value,
				colorMapDTO: {
					colorType: color.colorType,
					addColorDTO: {
						colorType: color.colorType,
						name: color.colorType,
						representedBy: 'PANTONE_OR_HEX_CODE',
						compositeColorList: color.selectedPantoneColorList?.map((pantone) => ({
							id: pantone?.id,
							name: pantone?.name,
							code: pantone?.code,
							hexCode: pantone?.hexCode
						}))
					},
					mainColorIdList: color.selectedGroupColorList?.map((group) => group.id)
				},
				details: {
					fabricCompositionPartList: item.compositions.map((comp) => ({
						id: comp.composition.id,
						percentage: comp.percentage,
						fiberName: comp.composition.value
					})),
					GSM: item?.weight
				}
			};
		});
	}
};

export const generatePreliminaryItems = (
	requestBody,
	colorSections,
	selectedTrimsAndAccessoriesList,
	selectedMaterialType,
	inputData
) => {
	let preliminaryItemAddRequest = {};
	if (inputData.quantity) {
		preliminaryItemAddRequest.quantity = inputData.quantity;
	}
	if (selectedMaterialType.materialType === 'TRIMS') {
		preliminaryItemAddRequest.trimsCategory = selectedTrimsAndAccessoriesList.id;
	}
	if (selectedMaterialType.materialType === 'ACCESSORIES') {
		preliminaryItemAddRequest.brandingCategory = selectedTrimsAndAccessoriesList.id;
	}
	if (colorSections.length > 0) {
		let color = colorSections[0];
		preliminaryItemAddRequest.colorMapDTO = {
			colorType: color.colorType,
			addColorDTO: {
				colorType: color.colorType,
				name: color.colorType,
				representedBy: 'PANTONE_OR_HEX_CODE',
				compositeColorList: color.selectedPantoneColorList?.map((pantone) => ({
					id: pantone?.id,
					name: pantone?.name,
					code: pantone?.code,
					hexCode: pantone?.hexCode
				}))
			},
			mainColorIdList: color.selectedGroupColorList?.map((group) => group.id)
		};
	}
	requestBody.preliminaryItemAddRequestList = [preliminaryItemAddRequest];
};

export const getMaterialRequisitionRequestBody = (
	inputData,
	selectedMaterialType,
	selectedCollectionOrFolder,
	selectedCollectionOrFolderList,
	selectedBrandList,
	selectedTrimsAndAccessoriesList,
	selectedMaterialTypeList,
	files,
	colorSections,
	materials
) => {
	const isSwatchSelected = selectedMaterialType.materialType === MATERIAL_REQUISITION_TYPE[1].constant;

	let requestBody = {
		requiredWithinDate: inputData.requiredDate,
		details: inputData.description,
		purpose: selectedMaterialType.requisitionPurpose,
		brandId: selectedBrandList.value,
		requisitionType: selectedMaterialType.materialType
	};
	if (selectedCollectionOrFolder?.id === 'COLLECTION') {
		requestBody.collectionId = selectedCollectionOrFolderList.value;
	} else {
		requestBody.favoriteFolderId = selectedCollectionOrFolderList.value;
	}
	if (selectedBrandList?.value) {
		requestBody.brandId = selectedBrandList.value;
	}
	if (selectedMaterialTypeList.length > 0) {
		requestBody.fabricConstructionGroupIdList = selectedMaterialTypeList.map((item) => item.value);
	}
	if (files?.length > 0) {
		requestBody.documentDTOList = files;
	}

	if (
		selectedMaterialType.materialType === MATERIAL_REQUISITION_TYPE[0].constant &&
		[MATERIAL_REQUISITION_PURPOSE[0].constant, MATERIAL_REQUISITION_PURPOSE[2].constant].includes(
			selectedMaterialType.requisitionPurpose
		)
	) {
		generateColorDtoList(colorSections, requestBody);
	} else if (
		isSwatchSelected ||
		([MATERIAL_REQUISITION_TYPE[0].constant].includes(selectedMaterialType.materialType) &&
			selectedMaterialType.requisitionPurpose === MATERIAL_REQUISITION_PURPOSE[1].constant)
	) {
		generatePreliminaryItemForBuyerRequestFabric(materials, requestBody);
	} else {
		generatePreliminaryItems(
			requestBody,
			colorSections,
			selectedTrimsAndAccessoriesList,
			selectedMaterialType,
			inputData
		);
	}

	return requestBody;
};

export const validateFabricPreliminaryValidation = (inputData, selectedFabricType) => {
	let errorObj = {};
	if (!selectedFabricType?.value) {
		errorObj['fabricTypeError'] = 'Fabric type is required';
	}
	if (!inputData?.gsm) {
		errorObj['gsmError'] = 'GSM is required';
	}
	if (!inputData?.quantity) {
		errorObj['quantityError'] = 'Quantity is required';
	}
	if (!inputData?.price) {
		errorObj['priceError'] = 'Price is required';
	}

	if (inputData?.compositions) {
		inputData.compositions.forEach((comp, i) => {
			if (!comp?.percentage) {
				errorObj[`composition_percentage_0_${i}`] = 'Composition is required';
			}
			if (!comp?.composition) {
				errorObj[`composition_type_0_${i}`] = 'Composition type is required';
			}
		});
		const totalPercentage = inputData.compositions.reduce(
			(sum, comp) => sum + (comp?.percentage || 0),
			0
		);
		if (totalPercentage !== 100) {
			errorObj[`composition_percentage_0_0`] = 'Total composition percentage must be 100%';
		}
	} else {
		errorObj[`composition_percentage_0_0`] = 'Composition is required';
		errorObj[`composition_type_0_0`] = 'Composition type is required';
	}

	return errorObj;
};

export const generateFabricPreliminaryItem = (inputData, selectedFabricType) => {
	return {
		price: inputData.price,
		quantity: inputData.quantity,
		fabricConstructionGroupId: selectedFabricType?.value,
		details: {
			fabricCompositionPartList: inputData.compositions.map((comp) => ({
				id: comp.composition.id,
				percentage: comp.percentage,
				fiberName: comp.composition.value
			})),
			GSM: inputData?.gsm
		}
	};
};

export const renderFabricComposition = (material) => {
	let str = material?.details?.GSM ? `${material?.details?.GSM} GSM` : '';
	const nameList = material?.details?.fabricCompositionPartList?.map(
		(composition) => `${composition?.percentage}% ${capitalizeFirstLetter(composition.fiberName)}`
	);
	str += nameList?.length > 0 ? `, ${nameList.join(', ')}` : '';
	return <p>{str}</p>;
};

export const renderFabricType = (material) => {
	return capitalizeFirstLetter(material?.fabricConstructionGroupResponse?.fabricType);
};

export const mapSubCategory = (subItems) => {
	return subItems?.map((subItem) => ({
		id: subItem.id,
		name: subItem.name,
		count: subItem.count
	}));
};

export const mapFabricTypeList = (fabricConstructoinGroupList) => {
	return fabricConstructoinGroupList?.map((item, index) => ({
		id: `${index}_${item.constant}`,
		name: item.name,
		count: item.count,
		subCategory: [
			{
				name: 'All',
				id: 'ALL',
				count: item?.count
			},
			...mapSubCategory(item?.fabricConstructionGroupList)
		]
	}));
};

export const isShowMaterialRequisitionBtn = () => {
	let primaryUserType = getPrimaryUserType();
	return [
		'ADMIN',
		'ACCOUNT_MANAGER',
		'FASHION_DESIGNER',
		'PROJECT_MANAGER',
		'PRODUCT_DEVELOPMENT',
		'MERCHANDISER',
		'GRAPHICS_DESIGNER'
	].includes(primaryUserType);
};

export const isMaterialTeam = () => {
	let primaryUserType = getPrimaryUserType();
	return ['ADMIN', 'MATERIAL_MANAGEMENT'].includes(primaryUserType);
};

export const isStoreManager = () => {
	let primaryUserType = getPrimaryUserType();
	return ['ADMIN', 'INVENTORY_MANAGEMENT'].includes(primaryUserType);
};

export const renderColorsColumn = (colorResponseList = []) => {
	return (
		<ul className="d-flex gap-1 flex-wrap">
			{colorResponseList?.map((color) => {
				if (color?.colorResponse?.compositeColorList?.length > 0) {
					return color?.colorResponse?.compositeColorList.map((colorItem) => (
						<li
							className="d-flex justify-content-start align-items-center"
							key={`key_${colorItem?.id}`}
						>
							<span
								className="color-icon mr-1"
								style={{
									background: colorItem?.hexCode
								}}
							/>
							<span className="code gray_dark_02 regular-14">
								{colorItem?.code || colorItem?.name}
							</span>
						</li>
					));
				} else {
					return color?.colorGroupResponseList?.map((colorItem) => (
						<li
							className="d-flex justify-content-start align-items-center"
							key={`key_${colorItem?.id}`}
						>
							<span
								className="color-icon mr-1"
								style={{
									background: colorItem?.hexCode
								}}
							/>
							<span className="code gray_dark_02 regular-14">
								{colorItem?.code || colorItem?.name}
							</span>
						</li>
					));
				}
			})}
		</ul>
	);
};
